import { useWsmFeeCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { getMutationState } from "@dashboard/misc";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router";

import WsmFeeDetailsPage from "../components/WsmFeeDetailsPage/WsmFeeDetailsPage";
import WsmProductField from "../components/WsmProductField/WsmProductField";
import { getWsmComposeErrorMessage } from "../errors";
import { sectionMessages } from "../messages";
import { readWsmProductPrefill, wsmFeeUrl } from "../urls";
import { emptyFeeFormData, getFeeCreateInput } from "../utils";

export const WsmFeeCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  // Opened from a product page, this screen already knows its product.
  const prefill = readWsmProductPrefill(useLocation().search);
  const [product, setProduct] = useState(prefill?.id ?? "");
  const [createFee, createFeeOpts] = useWsmFeeCreateMutation({
    onCompleted: result => {
      const fee = result.wsmFeeCreate?.fee;

      if (fee && !result.wsmFeeCreate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmFeeUrl(fee.id));
      }
    },
  });
  const errors = createFeeOpts.data?.wsmFeeCreate?.errors ?? [];
  const productError = errors.find(error => error.field === "product");

  return (
    <WsmFeeDetailsPage
      title={intl.formatMessage(sectionMessages.feeCreateTitle)}
      currencyCode={null}
      initialData={emptyFeeFormData()}
      errors={errors}
      disabled={createFeeOpts.loading}
      saveButtonBarState={getMutationState(createFeeOpts.called, createFeeOpts.loading, errors)}
      productField={
        <WsmProductField
          value={product}
          knownProduct={prefill}
          disabled={createFeeOpts.loading}
          error={getWsmComposeErrorMessage(productError, intl)}
          onChange={setProduct}
        />
      }
      onSubmit={formData => createFee({ variables: { input: getFeeCreateInput(formData, product) } })}
    />
  );
};

export default WsmFeeCreateView;
